"use client"
import React from 'react'
import { motion } from 'framer-motion';
import { CareerForm, } from '@/components'
const CareerFormClientSide = () => {
  return (
    <motion.div
        className="relative z-10 max-w-lg px-4 md:max-w-2xl w-full  bg-gray pt-6 bg-black text-white  bg-opacity-90 rounded-lg shadow-lg shadow-white "
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <CareerForm />
      </motion.div>
  )
}

export default CareerFormClientSide